<template>
  <SogPage title="Kfz-Zulassungen">
    <SogCard title="">
      <SogCardActions :is-toolbar="true">
        <SogCardActionButton
          v-show="_vehicleRegistrationId"
          mdi-icon="mdi-information"
          tooltip="Details anzeigen"
          @click="onDetails"
        />
        <SogTextBox
          v-model="_listPageFilter.number"
          placeholder="eVB/VR-Nummer"
          :interval-modified="onSearch"
        />
        <SogTextBox
          v-model="_listPageFilter.kennzeichen"
          placeholder="Kennzeichen"
          :interval-modified="onSearch"
        />
        <!--
                <SogTextBox
                  v-model="_halterName"
                  placeholder="Haltername"
                  :interval-modified="onNumberModified"
                />
        -->
        <SogTextBox
          v-model="_listPageFilter.FIN"
          placeholder="Fahrzeug Id Nummer"
          :interval-modified="onSearch"
        />
        <div style="width: 80px">
          <SogDropDownList
            v-model="_listPageFilter2.imBestand"
            placeholder="Im Bestand"
            :data-source="_lstYesNo"
            :fields="_fields"
            popup-width="80px"
          />
        </div>

        <div style="width: 80px">
          <SogDropDownList
            v-model="_listPageFilter2.ignorierte"
            placeholder="Ignorierte"
            :data-source="_lstYesNo"
            :fields="_fields"
            popup-width="80px"
          />
        </div>
        <SogCardActionButton
          mdi-icon="mdi-car-search"
          tooltip="Unbekante Zulassungen"
          @click="onUnknownSearch"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Search"
          @click="onSearch"
        />
        <SogCardActionButton
          :kind="SogButtonKind.FilterRemove"
          @click="onClear"
        />

        <SogCardActionButton :kind="SogButtonKind.Back" />
      </SogCardActions>
      <SogCardContent>
        <VehicleRegistrationListComponent
          ref="_listComponent"
          @selected="onSelected"
        />
      </SogCardContent>
    </SogCard>
  </SogPage>
</template>

<script setup lang="ts">
import SogPage from "@/shared/ui/SogPage.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import VehicleRegistrationListComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationListComponent.vue";
import {onMounted, reactive, ref, watch} from "vue";
import SogGrid from "@/shared/ui/SogGrid.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";

import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import {useVehicleRegistrationStore} from "@/modules/VehicleRegistration/store";
import {IdType} from "@/shared/model/idType";

const _halterName = ref("");
const _lstYesNo = reactive([
  {id: "no", value: "Nein"},
  {id: "yes", value: "Ja"},
  {id: "all", value: "Alle"},
]);
const _fields = {text: "value", value: "id"};
const _listComponent = ref<InstanceType<typeof SogGrid> | null>(null);
const _vehicleStore = useVehicleRegistrationStore();
const _navigationStore = useNavigationStore();
const _vehicleRegistrationId = ref<string | undefined>(undefined);
const {listPageFilter2: _listPageFilter2,listPageFilter: _listPageFilter} = storeToRefs(_vehicleStore);


/*const onRefresh = () => {
  _listComponent.value?.refresh()
}*/

function search() {
  if (!_listComponent.value || !_listComponent.value.adaptor) return;
  _listComponent.value?.adaptor.removePredicate("number");
  if (_listPageFilter.value.number)
    _listComponent.value?.adaptor.addPredicate(
      "number",
      "contains",
      _listPageFilter.value.number.toUpperCase()
    );

  _listComponent.value?.adaptor.removePredicate("halterName");
  if (_halterName.value) {
    _listComponent.value?.adaptor.addPredicate(
      "halterName",
      "contains",
      _halterName.value.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate(
    "fahrzeugIdentifizierungsNummer"
  );
  if (_listPageFilter.value.FIN) {
    _listComponent.value?.adaptor.addPredicate(
      "fahrzeugIdentifizierungsNummer",
      "contains",
      _listPageFilter.value.FIN.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate("kennzeichen");
  if (_listPageFilter.value.kennzeichen) {
    _listComponent.value?.adaptor.addPredicate(
      "kennzeichen",
      "contains",
      _listPageFilter.value.kennzeichen.toUpperCase()
    );
  }

  _listComponent.value?.adaptor.removePredicate("insurance");
  if (_listPageFilter2.value.imBestand === "yes") {
    _listComponent.value?.adaptor.addPredicate("insurance", "equal", "yes");
  }
  if (_listPageFilter2.value.imBestand === "no") {
    _listComponent.value?.adaptor.addPredicate("insurance", "equal", "no");
  }

  _listComponent.value?.adaptor.removePredicate("ignore");
  if (_listPageFilter2.value.ignorierte === "yes") {
    _listComponent.value?.adaptor.addPredicate("ignore", "equal", "yes");
  }
  if (_listPageFilter2.value.ignorierte === "no") {
    _listComponent.value?.adaptor.addPredicate("ignore", "equal", "no");
  }

  _listComponent.value.refresh();
}

onMounted(() => {
  search();
});

watch(_listPageFilter2.value, (value) => {
  if (value.imBestand === "yes" && _listPageFilter2.value.ignorierte === "yes") {
    _listPageFilter2.value.ignorierte = "all";
    return;
  }
  search();
});


function onSelected(value?: string) {
  _navigationStore.currentVehicleRegistrationId = value;
  _vehicleRegistrationId.value = value;
  /* _vRstore.vehicleRegistrationId = value
   console.log(_vRstore.vehicleRegistrationId)*/
}

async function onDetails() {
  if (_vehicleRegistrationId.value) {
    await _navigationStore.showObject(IdType.VehicleRegistration, _vehicleRegistrationId.value)
  }
}

function onSearch() {
  search();
}

function onUnknownSearch(){
  _listPageFilter2.value.ignorierte = "no";
  _listPageFilter2.value.imBestand = "no"
}

function onClear(){
  _listPageFilter.value.number = "";
  _listPageFilter.value.FIN = "";
  _listPageFilter.value.kennzeichen = "";
  _listPageFilter2.value.ignorierte = "all";
  _listPageFilter2.value.imBestand = "all";
}

</script>


<style scoped></style>
